import { render, staticRenderFns } from "./set-pass.vue?vue&type=template&id=3a4a7435&scoped=true&"
import script from "./set-pass.vue?vue&type=script&lang=js&"
export * from "./set-pass.vue?vue&type=script&lang=js&"
import style0 from "./set-pass.vue?vue&type=style&index=0&id=3a4a7435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a7435",
  null
  
)

export default component.exports